// extracted by mini-css-extract-plugin
export default {"image":"Preview_image__Llk3s","noPadding":"Preview_noPadding__VAgro"};